import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { firestore } from '../../../../../firebase';
import StateContext from '../../../../../StateContext';

function SingleLeagueTemplate({league, topLeaguesFB}) {

    const appState = useContext(StateContext)

    const [error, setError] = useState("")
    const [message, setMessage] = useState("")
    const [added, setAdded] = useState(false)

    const [topLeaguesAdded, setTopLeaguesAdded] = useState(topLeaguesFB)

    useEffect(() => {

        if (topLeaguesAdded) {
            const isLeagueAdded = topLeaguesAdded.filter(currentLeague => {
                //console.log(league.league_id, "===", currentLeague.league_id)
                return league.league_id === currentLeague.league_id
            })

            console.log(isLeagueAdded)
    
            if (isLeagueAdded.length) {
                setAdded(true)
            }
        }



    }, [topLeaguesAdded])

    async function addLeagueHandler(e) {
        console.log("CLICKED")
        e.preventDefault();

        if (added) {
            setError("League Added already")
            console.log("League ADDED ALREADY")
        } else {
            try {
                const topLeaguesRef = firestore.collection("top-leagues");
                const data = {
                    league_id: league.league_id,
                    league_logo: league.logo,
                    league_name: league.name,
                    order: 5
                }
                const response = await topLeaguesRef.add(data);
                console.log(response)
                setMessage("Added")
                console.log("ADDED")
            } catch (error) {
                setError(error.message)
                console.log(error, "error")
            }
        }


    }

    return (
        <div key={league.league_id} className="col-md-6 col-lg-4 col-xl-3">
            <div className="mb-2 card card-body">
                <div>
                    <Link to={`/leagues/${league.league_id}`}>
                        {league.name} <span><img style={{maxWidth: "20px", maxHeight: "20px"}} src={league.logo} /></span> 
                    </Link>
                    {appState.loggedIn && (
                        <span className="float-right">
                            <i onClick={addLeagueHandler} className={message || added ? "fas fa-check text-success" : error ? "fas fa-bug text-danger" : "fas fa-plus text-primary"}></i>
                        </span>
                    )}
                </div>
            </div>
        </div>
    )
}
export default SingleLeagueTemplate